import notification from './notification';

export default notification;
